var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#approved)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0FDF4",
    d: "M4.594 8.219a.656.656 0 1 1 1.312 0v2.625a.656.656 0 0 1-1.312 0V8.219ZM6.344 8.146v2.376c0 .331.187.634.483.782l.022.011c.243.122.511.185.783.185h2.37a.875.875 0 0 0 .857-.703l.525-2.625a.875.875 0 0 0-.858-1.047H8.97v-1.75a.875.875 0 0 0-.875-.875.438.438 0 0 0-.438.438v.291c0 .379-.123.747-.35 1.05l-.612.817a1.75 1.75 0 0 0-.35 1.05Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "approved"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.25e54d87cef1ffa508b45f969843fbf1.svg";
export { ForwardRef as ReactComponent };